<ion-app class="scanner-hide" dir="{{ textDir }}">
  <!-- <div style="    position: absolute;top: 1px;right: 10px;z-index: 10;">
    Speed <label >{{speed}} Mbps</label>  
  </div> -->
  <!-- <div style="    position: absolute;top: 50px;left: 30px;z-index: 10;">
    Network <label >{{network['effectiveType']}}</label>  
  </div> -->

  <!-- <th-banner-bubble *ngIf="showBubble"></th-banner-bubble> -->

  <ion-router-outlet *ngIf="!showTabs" id="mainContent"></ion-router-outlet>
 <!-- Shield User Footer Container -->
  <app-shield-footer *ngIf="showTabs && appService?.appData?.userInfo?.shield_user " [app_footer_TAB_theme]="app_footer_TAB_theme"
    [changeTabBg]="changeTabBg" [currentPage]="currentPage" [activateLeagueTheme]="false" [activateLeagueTheme2]="leagueService.activateLeagueTheme"
    [replaceLeftTabsWtBtn]="replaceLeftTabsWtBtn" [replaceRightTabsWtBtn]="replaceRightTabsWtBtn"
    [overdueActionCount]="overdueActionCount" [connectionState]="appService.connectionState"
    [isKeyboardOpen]="isKeyboardOpen" [isControllerOptionOpen]="isControllerOptionOpen" [bottomPadding]="bottomPadding"
    [bogTourButtonStatus]="bogTourButtonStatus" [showCompassIcon]="showCompassIcon" [tripTimer]="tripTimer"
    [is_obs_screen]="is_obs_screen" [vpcHazService]="vpcHazService" [currentTour]="currentTour"
    [hasRnDRoleFn]="hasRnDRole.bind(this)" [getFooterTABBtnFn]="getFooterTABBtn.bind(this)"
    [getConversationtextFn]="getConversationtext.bind(this)" (homeClick)="on_home_click()"
    (actionMgmtClick)="action_mgmt()" (performanceClick)="performance()" (hamburgerClick)="openHamburger()"
    (checkStatusClick)="checkStatus()" (leftButtonClick)="replaceLeftTabsWtBtn?.click()"
    (rightButtonClick)="replaceRightTabsWtBtn?.click()" (insideBogTourClick)="openIntermediateOptions()"
    (footerScannerBtn)="footerScannerBtn($event)" (showMoreOption)="showMoreOption()" (startBogTour)="startBogTour()"
    (openControllerOptions)="openControllerOptions()" (zoneOption)="zoneOption()" (rapidOption)="rapidOption()"
    (openIntermediateOptions)="openIntermediateOptions()"  [showTabs]="showTabs"></app-shield-footer>

  <!-- Non-Shield User Footer Container -->
  <app-non-shield-footer *ngIf="showTabs && !appService?.appData?.userInfo?.shield_user " [app_footer_TAB_theme]="app_footer_TAB_theme" 
    [changeTabBg]="changeTabBg" [currentPage]="currentPage" [activateLeagueTheme]="false" [activateLeagueTheme2]="leagueService.activateLeagueTheme"
    [replaceLeftTabsWtBtn]="replaceLeftTabsWtBtn" [replaceRightTabsWtBtn]="replaceRightTabsWtBtn"
    [overdueActionCount]="overdueActionCount" [connectionState]="appService.connectionState"
    [isKeyboardOpen]="isKeyboardOpen" [isControllerOptionOpen]="isControllerOptionOpen" [bottomPadding]="bottomPadding"
    [bogTourButtonStatus]="bogTourButtonStatus" [showCompassIcon]="showCompassIcon" [tripTimer]="tripTimer"
    [is_obs_screen]="is_obs_screen" [vpcHazService]="vpcHazService" [currentTour]="currentTour"
    [hasRnDRoleFn]="hasRnDRole.bind(this)" [getFooterTABBtnFn]="getFooterTABBtn.bind(this)"
    [getConversationtextFn]="getConversationtext.bind(this)" (homeClick)="on_home_click()"
    (actionMgmtClick)="action_mgmt()" (performanceClick)="performance()" (hamburgerClick)="openHamburger()"
    (checkStatusClick)="checkStatus()" (leftButtonClick)="replaceLeftTabsWtBtn?.click()"
    (rightButtonClick)="replaceRightTabsWtBtn?.click()" (insideBogTourClick)="openIntermediateOptions()"
    (footerScannerBtn)="footerScannerBtn($event)" (showMoreOption)="showMoreOption()" (startBogTour)="startBogTour()"
    (openControllerOptions)="openControllerOptions()" (zoneOption)="zoneOption()" (rapidOption)="rapidOption()"
    (openIntermediateOptions)="openIntermediateOptions()" [showTabs]="showTabs"></app-non-shield-footer>


  <!-- </ion-footer> -->
</ion-app>

<div class="scanner-ui">
  <!-- <ion-row class="flashlight-scanner ion-align-items-center">
    <ion-col class="ion-no-padding ion-text-center">
      <ion-button expand="block" (click)="flashLightOn()">
        {{torchOnOff}}
      </ion-button>
    </ion-col>
  </ion-row>    
  <ion-row class="cancel-scanner ion-align-items-center">
    <ion-col class="ion-no-padding ion-text-center">
      <ion-button expand="block" (click)="stopScanner()">
        {{'ADD_QR.BTN_CANCEL' | translate }}
      </ion-button>
    </ion-col>
  </ion-row> -->
  <ion-row class="flashlight-scanner">
    <ion-col class="scanCodeText">
      {{ "SCAN_QR_CODE" | translate }}
    </ion-col>
    <ion-col align-self-end>
      <!-- <span [ngClass]="!torchOnOff ?  : ''"> -->
      <img [ngClass]="torchOnOff ? 'flashIcon' : 'flashOffIcon'"
        [src]="torchOnOff ? 'assets/img/torch.svg' : 'assets/img/torchOff.svg'" id="flashLightOn"
        (click)="flashLightOn()" />
      <!-- </span>  -->
      <img class="closeIcon" id="stopScanner" src="assets/img/closeIcon.svg" (click)="stopScanner()" />
    </ion-col>
  </ion-row>
  <ion-row class="scanner-instruction">
    <ion-col>
      <p class="instruction-text">{{'SHIELD.CAMERA_QR_MESSAGE'|translate}}</p>
    </ion-col>
  </ion-row>
  <div class="scan-box"></div>
</div>